"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableHeaderCell = void 0;
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ChevronDownIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronDownIcon"));
const ChevronUpIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronUpIcon"));
const GrabIcon_1 = __importDefault(require("@opsbase/web-icons/icons/GrabIcon"));
const PinIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PinIcon"));
const UnpinIcon_1 = __importDefault(require("@opsbase/web-icons/icons/UnpinIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importStar(require("react"));
const DVLTableCell_1 = __importDefault(require("../DVLTableCell"));
const makeMyClasses = color => ({
    root: {
        position: 'relative',
        backgroundColor: 'white',
        justifyContent: 'space-between',
        opacity: 1,
        transition: 'opacity 0.3s, background-color 0.3s',
        borderTop: '2px solid transparent',
        borderBottom: '2px solid transparent',
        borderTopColor: color ? `${color.main}` : 'transparent',
        padding: 8,
        '& .grabIcon': {
            position: 'absolute',
            opacity: 0,
            left: -16,
            cursor: 'pointer',
            transition: 'opacity 0.3s, left 0.3s',
        },
        '& .label': {
            position: 'relative',
            left: 0,
            opacity: 1,
            transition: 'opacity 0.3s, left 0.3s',
        },
        '& .sortIcon': {
            position: 'absolute',
            right: -16,
            opacity: 0,
            cursor: 'pointer',
            transition: 'opacity 0.3s, right 0.3s',
        },
        '& .pinIcon': {
            position: 'absolute',
            right: -16,
            opacity: 0,
            cursor: 'pointer',
            transition: 'opacity 0.3s, right 0.3s',
        },
        '&:hover': {
            backgroundColor: lib_palette_1.default.LightBlue.main,
        },
        '&:hover .grabIcon': {
            opacity: 1,
            left: 0,
            pointerEvents: 'unset',
        },
        '&:hover .label': {
            left: 16,
            opacity: 0.5,
        },
        '&:hover .sortIcon': {
            opacity: 1,
            right: 0,
        },
        '&:hover .pinIcon': {
            opacity: 1,
            right: 20,
        },
    },
});
function DVLTableHeaderCell(props) {
    const dt = (0, useDataTree_1.default)();
    const { idx = 0, field, color } = props;
    const { sortBy, sortByDesc, pinField, fields } = (0, useView_1.default)(dt.viewId);
    const { setSortBy, setPinField, toggleHighlightedField } = (0, useViewActions_1.default)(dt.viewId);
    const sorted = sortBy && sortBy.key === field.key;
    const isFirstCol = idx === 0;
    const isSecondCol = idx === 1;
    const isLastCol = idx === fields.length - 1;
    const isPinned = (pinField === null || pinField === void 0 ? void 0 : pinField.key) === field.key;
    const draggable = idx > 0 && !isPinned;
    const myCss = (0, web_css_1.default)(makeMyClasses, [color]);
    const width = field.width;
    const label = (0, getFromStringOrFunction_1.getFromStringOrFunction)(field.label);
    const handleClick = (0, react_1.useCallback)(() => {
        toggleHighlightedField(field);
        if (!field.sortable)
            return;
        setSortBy(field, sorted ? !sortByDesc : true);
    }, [toggleHighlightedField, field, setSortBy, sorted, sortByDesc]);
    const handlePinClick = (0, react_1.useCallback)(() => {
        if (isPinned) {
            setPinField(undefined);
        }
        else {
            setPinField(field);
        }
    }, [setPinField, isPinned, field]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(DVLTableCell_1.default, { width: width, key: 'item_' + idx, isFirstCol: isFirstCol, isLastCol: isLastCol, isPinned: isPinned, className: myCss.root },
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            draggable && (react_1.default.createElement(Pane_1.default, { classes: { root: 'grabIcon' } },
                react_1.default.createElement(GrabIcon_1.default, null))),
            react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: 'label' } },
                react_1.default.createElement(Tooltip_1.default, { tip: label, minTipLength: desiredLabelLength },
                    react_1.default.createElement(Text_1.default, { color: "grey" }, chopLabel(label)))),
            (isPinned || (!pinField && isSecondCol)) && (react_1.default.createElement(Pane_1.default, { classes: { root: 'pinIcon' }, onClick: handlePinClick }, isPinned ? react_1.default.createElement(UnpinIcon_1.default, { size: 20 }) : react_1.default.createElement(PinIcon_1.default, { size: 20 }))),
            field.sortable && (react_1.default.createElement(Pane_1.default, { classes: { root: 'sortIcon' } }, sorted && sortByDesc ? (react_1.default.createElement(ChevronDownIcon_1.default, { onClick: handleClick })) : (react_1.default.createElement(ChevronUpIcon_1.default, { onClick: handleClick }))))))), [
        width,
        idx,
        isFirstCol,
        isLastCol,
        isPinned,
        myCss,
        draggable,
        label,
        pinField,
        isSecondCol,
        handlePinClick,
        field,
        sorted,
        sortByDesc,
        handleClick,
    ]);
}
exports.DVLTableHeaderCell = DVLTableHeaderCell;
exports.default = DVLTableHeaderCell;
const desiredLabelLength = 38;
function chopLabel(str) {
    if (!str)
        return '';
    if (str.length < desiredLabelLength + 4)
        return str;
    str = str.substr(0, desiredLabelLength);
    str = str.substr(0, Math.max(Math.min(str.length, desiredLabelLength - 8), str.lastIndexOf(' ')));
    return str + '...';
}
